import { module } from 'angular';

import { default as detailedViewName, DetailedView } from './detailed-view.component.ajs';

export default module('hypervision.detailed-view', []).component(detailedViewName, new DetailedView()).name;
